// src/common/notification.service.js
class NotificationService {
  /**
   * Show a success notification
   * @param {string} message - The message to display
   * @param {string} title - Optional title for the notification
   * @param {number} duration - Duration in milliseconds (0 for persistent)
   */
  static success(message, title = '', duration = 5000) {
    this.show('success', message, title, duration)
  }

  /**
   * Show a warning notification
   * @param {string} message - The message to display
   * @param {string} title - Optional title for the notification
   * @param {number} duration - Duration in milliseconds (0 for persistent)
   */
  static warning(message, title = '', duration = 5000) {
    this.show('warning', message, title, duration)
  }

  /**
   * Show an error notification
   * @param {string} message - The message to display
   * @param {string} title - Optional title for the notification
   * @param {number} duration - Duration in milliseconds (0 for persistent)
   */
  static error(message, title = '', duration = 5000) {
    this.show('error', message, title, duration)
  }

  /**
   * Show an info notification
   * @param {string} message - The message to display
   * @param {string} title - Optional title for the notification
   * @param {number} duration - Duration in milliseconds (0 for persistent)
   */
  static info(message, title = '', duration = 5000) {
    this.show('info', message, title, duration)
  }

  /**
   * Show a notification
   * @param {string} type - Type of notification (success, warning, error, info)
   * @param {string} message - The message to display
   * @param {string} title - Optional title for the notification
   * @param {number} duration - Duration in milliseconds (0 for persistent)
   */
  static show(type, message, title = '', duration = 5000) {
    // Emit event to show notification
    if (typeof window !== 'undefined' && window.VueRoot) {
      // For Vue 2, we need to emit from the root instance
      if (window.VueRoot.$root) {
        window.VueRoot.$root.$emit('add-notification', {
          type,
          message,
          title,
          duration,
        })
        return
      }
    }

    // Fallback if Vue instance is not available
    console.warn('Vue instance not available for notification')
  }

  /**
   * Remove a specific notification by ID
   * @param {string} id - The ID of the notification to remove
   */
  static remove(id) {
    if (typeof window !== 'undefined' && window.VueRoot) {
      if (window.VueRoot.$root) {
        window.VueRoot.$root.$emit('remove-notification', id)
        return
      }
    }

    // Fallback if Vue instance is not available
    console.warn('Vue instance not available for notification removal')
  }

  /**
   * Clear all notifications
   */
  static clear() {
    if (typeof window !== 'undefined' && window.VueRoot) {
      if (window.VueRoot.$root) {
        window.VueRoot.$root.$emit('clear-notifications')
        return
      }
    }

    // Fallback if Vue instance is not available
    console.warn('Vue instance not available for notification clearing')
  }
}

export default NotificationService
